import { ValidationErrors } from '@angular/forms';

const EMAIL_ERROR_MESSAGES: ValidationErrors = {
  required: () => 'Email is required.',
  pattern: () => 'Please enter a valid email address.',
};

export const FORGOT_PASSWORD_ERROR_MESSAGES = {
  email: EMAIL_ERROR_MESSAGES,
} as const;
